import { observable, action } from 'mobx'
import { StoreExt } from 'util/reactExt'
import { routeMap } from 'constants/routes'

const menus = [
  {
    url: '/usercenter',
    name: '个人中心',
  },
  {
    url: routeMap.LEVEL_UP.LEVEL_CONRIG.path,
    name: routeMap.LEVEL_UP.LEVEL_CONRIG.name,
  },
  {
    url: routeMap.LEVEL_UP.PASS_STATUS.path,
    name: routeMap.LEVEL_UP.PASS_STATUS.name,
  },
  {
    url: '/feedback',
    name: '反馈中心',
  },
  {
    url: '',
    name: '退出登录',
    logout: true,
  },
]
export class GlobalStore extends StoreExt {
  @observable userInfo = {} as PlainObject

  @observable staffInfo = {} as PlainObject

  // 进阶考试欢迎信
  @observable showLetter = false

  @observable
  userMessage = {
    data: {},
    total: 0,
  }

  // 个人中心菜单
  @observable menus = []
  // 是否显示用户指引
  @observable showGuide = false

  constructor() {
    super()
    let templateDraft = ''
    let templateDraftCreatedTime = ''
    if (localStorage.getItem('template_draft')) {
      templateDraft = localStorage.getItem('template_draft')
    }

    if (localStorage.getItem('template_draft_created_time')) {
      templateDraftCreatedTime = localStorage.getItem(
        'template_draft_created_time',
      )
    }

    localStorage.clear()
    localStorage.setItem('template_draft', templateDraft)
    localStorage.setItem(
      'template_draft_created_time',
      templateDraftCreatedTime,
    )
  }

  // autorun: 自动获取用户信息
  @action
  fetchUserInfo = async () => {
    const user = await this.api.user.getUserInfo()
    const study = await this.api.user.getStudyInfo()
    if (user && study) {
      this.setUserInfo({ user, study })
    }
  }

  @action
  setUserInfo = userInfo => {
    this.userInfo = userInfo
    // 暂时去除用户指引
    // this.showGuide = !userInfo.user.read_guide
    this.showGuide = false
  }

  @action
  getStaffInfo = async () => {
    const res = await this.api.level.getStaffInfo()
    this.setStaffInfo(res)
  }

  @action
  setStaffInfo = staffInfo => {
    this.staffInfo = staffInfo
    // 初始化个人中心菜单列表
    this.menus = menus

    const {
      can_config_check,
      can_view_check_pass_info,
      is_first_visit_lesson,
    } = staffInfo
    const staffAuthCode = can_config_check + can_view_check_pass_info // 0-没有配置和查看员工通关情况权限，1-有其中之一权限，2-都有权限

    if (staffAuthCode === 0) {
      const copiedMenus = Array.from(menus)
      copiedMenus.splice(1, 2)
      this.menus = copiedMenus
    } else if (staffAuthCode === 1 && !can_config_check) {
      const copiedMenus = Array.from(menus)
      copiedMenus.splice(1, 1)
      this.menus = copiedMenus
    } else if (staffAuthCode === 1 && !can_view_check_pass_info) {
      const copiedMenus = Array.from(menus)
      copiedMenus.splice(2, 1)
      this.menus = copiedMenus
    } else {
      this.menus = menus
    }

    // 设置进阶考试欢迎信
    this.setShowLetter(is_first_visit_lesson)
  }

  @action
  setShowLetter = bool => {
    this.showLetter = bool
  }

  @action
  fetchUserMessage = async (pageindex = 1, pagesize = 20) => {
    try {
      const { data: userMessage } = await this.api.user.unRead({
        pageindex,
        pagesize,
      })
      this.setUserMessage(userMessage)
    } catch (error) {}
  }

  // @action
  // setReadGuide = async () => {
  //   try {
  //     await this.api.user.setReadGuide()
  //     this.fetchUserInfo()
  //   } catch (error) {}
  // }

  @action
  setUserMessage = msg => {
    this.userMessage = msg
  }

  @action
  setAllMsgReaded = async () => {
    try {
      const res = await this.api.user.onRead()
      if (res.status === 200) {
        this.$message.success('全部标为已读成功！')
        this.fetchUserMessage()
      } else {
        this.$message.error(`标记失败，${res.data}`)
      }
    } catch (error) {}
  }
  @action
  setShowGuide = isShow => {
    this.showGuide = isShow
  }
}

export default new GlobalStore()
